import { gql } from '@apollo/client/core'

export const QUIETS_EXPORT = gql`
  mutation quietsExportSend {
    quietsExportSend {
      result {
        status
        message
      }
    }
  }
`

export interface QuietsExportResult {
  result: {
    message: string,
    status: string
  }
}
